/// <amd-module name="SuiteCommerce.Testimonials.TestimonialsCCT"/>
define("SuiteCommerce.Testimonials.TestimonialsCCT", ["require", "exports", "Handlebars", "SuiteCommerce.TestimonialsCCT.View"], function (require, exports, Handlebars, TestimonialsCCT_View_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            var cmsComponent = container.getComponent('CMS');
            if (cmsComponent) {
                cmsComponent.registerCustomContentType({
                    id: 'ns_sc_ext_ctestimonialscct',
                    view: TestimonialsCCT_View_1.TestimonialsCCTView,
                    options: {
                        container: container,
                    },
                });
                Handlebars.registerHelper('columnSize', function (testimonials) {
                    return 12 / testimonials.length;
                });
                Handlebars.registerHelper('singlePadding', function (testimonials) {
                    return testimonials.length === 1 ? 'single-testimonial-padding' : '';
                });
            }
        },
    };
});
